import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { inject } from '@angular/core';
import { JwtCookieService } from '@cyan/jwt-cookie';

export const jwtInterceptor: HttpInterceptorFn = (request, next) => {
  const apiUrl = environment.apiUrl;
  const isApiUrl = request.url.startsWith(apiUrl);

  if (isApiUrl) {
    const token = inject(JwtCookieService).getJwtCookie();
    if (token) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }
  }

  return next(request);
};
